import { useContext, useEffect, useState } from "react";
import NationalEvents from "./partials/NationalEvents";
import Training from "./partials/Training";
import MovieReview from "./partials/MovieReview";
import News from "./partials/News";
import Ads from "./partials/Ads";
import { COUNTRY_SEARCH, GET_ALL_CATEGORIES, GET_ALL_GIF_ADS, GET_BUSINESS_CATEGORIES, STATE_SEARCH, fetchData } from "../../components/Service";
import { Context } from "../../components/Context";
import OwlCarousel from "react-owl-carousel";
import { Link, useNavigate } from "../../../node_modules/react-router-dom/dist/index";
import Forum from "./partials/Forum";
import NrisTalk from "./partials/NrisTalk";
import StudentTalk from "./partials/StudentTalk";
import Blogs from "./partials/Blogs";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { scrollTop } from "../../components/Helper";
import RecentAds from "./partials/RecentAds";
import HotList from "./partials/HotList";
import DesiPage from "./partials/DesiPage";
import GrosaryStore from "./partials/GrosaryStore";
import StateForum from "./partials/StateForum";

const Home = () => {
	const navigate = useNavigate();
	const [topAds, setTopAds] = useState([]);
	const [context] = useContext(Context);
	const [businessCatList, setBusinessCatMenu] = useState([]);
	const [freeAdsCatList, setFreeAdsCatMenu] = useState([]);

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const getTopAds = (country_id, type,state_id) => {
		let value = {
			// country_id: country_id,
			// ad_position: type,
			country_id: country_id,
			ad_position: type,
			state_id: state_id,
		};
		fetchData(GET_ALL_GIF_ADS, "POST", value, false, false, (res) => {
			if (res.status) {
				setTopAds(res?.data);
			} else {
				setTopAds([]);
			}
		});
	};

	const getBusinessCatList = (country_id) => {
		fetchData(GET_BUSINESS_CATEGORIES, "POST", { country_id: country_id }, false, false, (res) => {
			if (res.status) {
				setBusinessCatMenu(res.data);
			} else {
				setBusinessCatMenu([]);
			}
		});
	};

	const getFreeAdsCatList = () => {
		fetchData(GET_ALL_CATEGORIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setFreeAdsCatMenu(res.data);
			} else {
				console.log(res);
			}
		});
	};

	const searchResult = (data) => {
		let payload = {
			country_id: context?.countryId,
			keyword: data.search_keyword,
		};

		if (context?.stateView) {
			payload = { ...payload, state_id: context?.stateId };
		}
		fetchData(context?.stateView ? STATE_SEARCH : COUNTRY_SEARCH, "POST", payload, false, false, (res) => {
			if (res.status) {
				localStorage.setItem("_nrissearch", data.search_keyword);

				navigate("/search-results", { state: { search_result: res?.data } });
			} else {
				toast.error("No search results found.");
			}
		});
	};

	const goToCreateAdsPage = (id, type, title) => {
		window.$(`#freeAdsCatModelSelect`).modal("hide");
		window.$(`#premiumAdsCatModelSelect`).modal("hide");
		navigate(`/classifieds/create-ads/${id}/${type}`, { state: { pageTitle: title ? title + " Ads" : "Classifieds Ads" } });
	};
	
	useEffect(() => {
		if (context?.countryId) {
			getTopAds(context?.countryId, "top",context?.stateId);
		}
	}, [context?.countryId]);

	useEffect(() => {
		scrollTop();
		if (context?.countryId) {
			getBusinessCatList(context?.countryId);
		}
	}, [context?.countryId]);

	useEffect(() => {
		getFreeAdsCatList();
	}, []);

	return (
		<>
			<section className="section-box">
				<div className="container-fluid banner-hero hero-1">
					<Ads adsType="left" limit={4} />
					<div className="search_area">
						<div className="row">
							<div className="col-xl-8">
								{context?.stateView ? (
									<div id="homebanner" className="carousel slide" data-bs-ride="carousel">
										<div className="carousel-inner">
											<div className="carousel-item active">
												<picture>
													<source media="(min-width: 1440px)" srcSet="/assets/images/slide1.jpg" />
													<source media="(min-width: 1025px)" srcSet="/assets/images/slide1-1480.jpg" />
													<source media="(min-width: 768px)" srcSet="/assets/images/slide1-767.jpg" />
													<source media="(min-width: 767px)" srcSet="/assets/images/slide1-1480.jpg" />
													<source media="(min-width: 575px)" srcSet="/assets/images/slide1-767.jpg" />
													<img src="assets/images/slide1-767.jpg" title="NRS USA" className="d-block w-100" alt="..." />
												</picture>

												<div className="carousel-caption">
													<h4 className="text-white fw-normal">
														You are in <span className="fw-bold state-text-color">{context?.stateName}</span> home page
													</h4>
													<h3 className="text-white fw-normal">
														Explore in <span className="fw-bold state-text-color">{context?.stateName}</span>
													</h3>
													<h5 className="text-white fw-semibold">
														What's happening in <span className="state-text-color">{context?.stateName}</span>?
													</h5>
												</div>
											</div>
										</div>
									</div>
								) : (
									<div id="homebanner" className="carousel slide" data-bs-ride="carousel">
										<div className="carousel-indicators">
											<button type="button" data-bs-target="#homebanner" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
											<button type="button" data-bs-target="#homebanner" data-bs-slide-to="1" aria-label="Slide 2"></button>
											<button type="button" data-bs-target="#homebanner" data-bs-slide-to="2" aria-label="Slide 3"></button>
											<button type="button" data-bs-target="#homebanner" data-bs-slide-to="3" aria-label="Slide 4"></button>
										</div>

										<div className="carousel-inner">
											<div className="carousel-item active">
												<picture>
													<source media="(min-width: 1440px)" srcSet="/assets/images/slide1.jpg" />
													<source media="(min-width: 1025px)" srcSet="/assets/images/slide1-1480.jpg" />
													<source media="(min-width: 768px)" srcSet="/assets/images/slide1-767.jpg" />
													<source media="(min-width: 767px)" srcSet="/assets/images/slide1-1480.jpg" />
													<source media="(min-width: 575px)" srcSet="/assets/images/slide1-767.jpg" />
													<img src="assets/images/slide1-767.jpg" title="NRS USA" className="d-block w-100" alt="..." />
												</picture>

												<div className="carousel-caption">
													<h3 className="text-white fw-semibold">Explore in USA</h3>
													<h5 className="text-white fw-normal ">What's happening in your State ?</h5>
												</div>
											</div>
											<div className="carousel-item">
												<picture>
													<source media="(min-width: 1440px)" srcSet="/assets/images/slide2.jpg" />
													<source media="(min-width: 1025px)" srcSet="/assets/images/slide2-1480.jpg" />
													<source media="(min-width: 768px)" srcSet="/assets/images/slide2-767.jpg" />
													<source media="(min-width: 767px)" srcSet="/assets/images/slide2-1480.jpg" />
													<source media="(min-width: 575px)" srcSet="/assets/images/slide2-767.jpg" />
													<img src="assets/images/slide2-767.jpg" title="NRS USA" className="d-block w-100" alt="..." />
												</picture>
												<div className="carousel-caption">
													<h3 className="text-white fw-semibold">Explore in India</h3>
													<h5 className="text-white fw-normal">What's happening in your State ?</h5>
												</div>
											</div>
											<div className="carousel-item">
												<picture>
													<source media="(min-width: 1440px)" srcSet="/assets/images/slide3.jpg" />
													<source media="(min-width: 1025px)" srcSet="/assets/images/slide3-1480.jpg" />
													<source media="(min-width: 768px)" srcSet="/assets/images/slide3-767.jpg" />
													<source media="(min-width: 767px)" srcSet="/assets/images/slide3-1480.jpg" />
													<source media="(min-width: 575px)" srcSet="/assets/images/slide3-767.jpg" />
													<img src="assets/images/slide3-767.jpg" title="NRS USA" className="d-block w-100" alt="..." />
												</picture>
												<div className="carousel-caption">
													<h3 className="text-white fw-semibold">Explore in Africa</h3>
													<h5 className="text-white fw-normal">What's happening in your State ?</h5>
												</div>
											</div>
											<div className="carousel-item">
												<picture>
													<source media="(min-width: 1440px)" srcSet="/assets/images/slide4.jpg" />
													<source media="(min-width: 1025px)" srcSet="/assets/images/slide4-1480.jpg" />
													<source media="(min-width: 768px)" srcSet="/assets/images/slide4-767.jpg" />
													<source media="(min-width: 767px)" srcSet="/assets/images/slide4-1480.jpg" />
													<source media="(min-width: 575px)" srcSet="/assets/images/slide4-767.jpg" />
													<img src="assets/images/slide4-767.jpg" title="NRS USA" className="d-block w-100" alt="..." />
												</picture>
												<div className="carousel-caption">
													<h3 className="text-white fw-semibold">Explore in New York</h3>
													<h5 className="text-white fw-normal">What's happening in your State ?</h5>
												</div>
											</div>
										</div>

										<button className="carousel-control-prev" type="button" data-bs-target="#homebanner" data-bs-slide="prev">
											<span className="carousel-control-prev-icon" aria-hidden="true"></span>
											<span className="visually-hidden">Previous</span>
										</button>
										<button className="carousel-control-next" type="button" data-bs-target="#homebanner" data-bs-slide="next">
											<span className="carousel-control-next-icon" aria-hidden="true"></span>
											<span className="visually-hidden">Next</span>
										</button>
									</div>
								)}
							</div>
							<div className="col-xl-4 d-none d-xl-inline-block ps-0">
								<div className="block-banner">
									<h1 className="heading-banner wow animate__animated animate__fadeInUp text-white mb-3">Search</h1>
									<div className="form-find wow animate__animated animate__fadeIn" data-wow-delay=".2s">
										<form className="needs-validation" onSubmit={handleSubmit(searchResult)}>
											<input
												className={`form-input input-keysearch mr-10`}
												placeholder="What are you looking for in..."
												{...register("search_keyword", {
													required: {
														value: true,
														message: "Search keyword is required.",
													},
													minLength: {
														value: 3,
														message: "Search keyword must be at least 3 characters.",
													},
												})}
											/>

											<button className="btn btn-default font-sm">
												{" "}
												<span className="d-flex align-items-center">
													<i className="fi fi-rs-search me-2 linehight0"></i> Search
												</span>{" "}
											</button>
										</form>
									</div>
									{errors.search_keyword && <div className="invalid-feedback d-block">{errors.search_keyword.message}</div>}
									<h6 className="mt-4 mb-3 wow animate__animated animate__fadeInUp text-white " data-wow-delay=".3s">
										Start Quick Search..
									</h6>
									<p>
										{businessCatList?.map((item) => (
											<Link key={item.id} to={`/business/${item.id}`} state={{ pageTitle: item.name }}>
												<img src={item?.icon} className="search_icon me-3" alt="..." />
											</Link>
										))}
									</p>
								</div>
							</div>
						</div>
					</div>
					<Ads adsType="right" limit={4} />
				</div>
			</section>
			<section className="section-box mt-0">
				<div className="section-box wow animate__animated animate__fadeIn">
					<div className="container-fluid">
						<div className="row d-flex align-items-stretch">
							<div className="col-md-12 mb-1">
								{topAds && topAds.length > 0 && (
									<OwlCarousel
										className="owl-carousel owl-theme custom-arrow"
										items={10}
										loop={true}
										margin={10}
										nav={true}
										dots={false}
										autoplay={true}
										autoplayTimeout={2000}
										responsive={{
											0: {
												items: 3,
											},
											600: {
												items: 5,
											},
											991: {
												items: 7,
											},
											1200: {
												items: 8,
											},
											1366: {
												items: 9,
											},
											1440: {
												items: 10,
											},
											1601: {
												items: 10,
											},
										}}
									>
										{topAds?.map((item, index) => (
											<div key={item.id} className="item">
												<Link  to={`${item?.click_url}`} target="_blank">
													<img src={item.image} alt="..." />
												</Link>
											</div>
										))}
									</OwlCarousel>
								)}
							</div>
							{context?.stateView ? <RecentAds catList={freeAdsCatList} /> : <Forum />}
							{context?.stateView ? <HotList catList={freeAdsCatList} /> : <NrisTalk />}
							<StudentTalk />
						</div>
					</div>
				</div>
			</section>

			<MovieReview />

			<section className="section-box mb-1">
				<div className="container-fluid">
					<div className="row">
						<NationalEvents />
						<Training />
					</div>
				</div>
			</section>

			{context?.stateView && (
				<section className="section-box mb-1">
					<div className="container-fluid">
						<div className="row">
							<GrosaryStore />
							<StateForum />
						</div>
					</div>
				</section>
			)}

			<div className="container-fluid mt-1">
				<div className="row align-items-stretch">
					<div className="col-lg-6 mb-1">
						<News />
					</div>
					<div className="col-lg-6 mb-1">{context?.stateView ? <DesiPage /> : <Blogs />}</div>
				</div>
			</div>

			<div
				className="modal fade pe-0"
				id="freeAdsCatModelSelect"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal modal-dialog-centered modal-dialog-scrollable modal-lg">
					<div className="modal-content">
						<button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
						<div className="modal-header d-block text-center border-bottom-0">
							<h5 className="text-brand-1 text-capitalize">Select Category To Create Free Ads</h5>
						</div>
						<div className="modal-body px-4 px-xl-5 py-3">
							<div className="card-body bg-white p-1 body-minh">
								<div className="row">
									{freeAdsCatList &&
										freeAdsCatList.length > 0 &&
										freeAdsCatList?.map((item) => (
											<div key={item.id} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 event_n mb-1">
												<div className="card-grid-2 hover-up h-100 mb-0">
													<div className="card-block-info position-relative">
														<div className="card-2-bottom">
															<div className="row d-flex align-items-center">
																<div className="col-12">
																	<a href="#!" className="btn btn-classified-2 text-white w-100" onClick={() => goToCreateAdsPage(item.id, "free", item.name)}>
																		{item.name}
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="modal fade pe-0"
				id="premiumAdsCatModelSelect"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal modal-dialog-centered modal-dialog-scrollable modal-lg">
					<div className="modal-content">
						<button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
						<div className="modal-header d-block text-center border-bottom-0">
							<h5 className="text-brand-1 text-capitalize">Select Category To Create Premium Ads</h5>
						</div>
						<div className="modal-body px-4 px-xl-5 py-3">
							<div className="card-body bg-white p-1 body-minh">
								<div className="row">
									{freeAdsCatList &&
										freeAdsCatList.length > 0 &&
										freeAdsCatList?.map((item) => (
											<div key={item.id} className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 event_n mb-1">
												<div className="card-grid-2 hover-up h-100 mb-0">
													<div className="card-block-info position-relative">
														<div className="card-2-bottom">
															<div className="row d-flex align-items-center">
																<div className="col-12">
																	<a href="#!" className="btn btn-classified-2 text-white w-100" onClick={() => goToCreateAdsPage(item.id, "premium", item.name)}>
																		{item.name}
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Home;
